module.exports = __webpack_public_path__ + "static/placeholder-8ad1a1fc09dd5f4eeadba6446275109e.png";